import { Pipe, PipeTransform } from '@angular/core';

/**
 * Filter out columns that should not show when editing
 *
 * @author Will Davis <will.davis@mtna.us>
 */
@Pipe({
  name: 'filterColumns',
})
export class FilterColumnsPipe implements PipeTransform {
  /**
   * @param columns table column ids to filter
   * @param editable whether the table is editable
   * @returns the filted down array of columns depending on if the table is editable
   */
  transform(columns: string[], editable: boolean): string[] {
    return editable ? columns.filter((c) => c !== 'selected') : columns.filter((c) => c !== 'editButton');
  }
}
